module.exports = __webpack_public_path__ + "media/foreign body.d1d7764c.wav";